import React from "react";
import { Package } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelProductSkuEconomicsAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Product & SKU Economics"
    subtitle="Portfolio-level contribution and concentration risk"
    badge="SKU"
    Icon={Package}
  />
);

export default FunnelProductSkuEconomicsAssessmentViewerV2;
